///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Namespaces
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.rfq = abcsetup.rfq || {};
abcsetup.rfq.supply_issues = abcsetup.rfq.supply_issues || {};
abcsetup.rfq.supply_issues.index = abcsetup.rfq.supply_issues.index || {};


///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Variables
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.rfq.supply_issues.index.table = null;


///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Methods
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.rfq.supply_issues.index = {
    init: function () {
        abcsetup.setTitle('Manage Supply Issues');

        this._initDataTable();
        this._bindFormSubmit();
        this._bindDownloadExportForm();
        this._bindStatusToggle();
        this._bindRfqEventStatusToggle();
        this._bindGCNFamilyFilter();
        this._bindCopySupplyIssueButtons();
        this._setupAddBlankCommentCheckbox();
        this._setupBulkRFQEventCreate();
        abcsetup.rfq.supply_issues.comments.init();
    },

    _initDataTable() {
        abcsetup.blockUI(true);
        const _this = this;
        const form = $('#supply-issues-form');
        let isInitialized = false;

        this.table = abcsetup.datatables.init($('table#supply_issues'), {
            bInfo: true,
            scroll_horizontal: true,
            responsive: false,
            lengthMenu: [[5, 10, 25, 50, 100, 500, 1000], [5, 10, 25, 50, 100, 500, 1000]],
            iDisplayLength: 25,
            dom: 'ltipB',
            order: [[25, "asc"]],
            stateSave: false,
            serverSide: true,
            scrollX: true,
            scrollY: '75vh',
            resetTable: false,
            searchVisible: false, // Don't search hidden columns, unless 'searchable' is set

            ajax: {
                url: window.location.origin + "/api/rfq/supply_issues",
                type: 'POST',
                beforeSend: function (xhr) {
                    if (!isInitialized) {
                        isInitialized = true;
                        return;
                    }

                    // Couldn't use abcsetup.alerts.confirm here because this has to be a synchronous operation and can't be done through promises or callbacks.
                    if (abcsetup.formDirtyChecker.isDirty(form) && !window.confirm('You have unsaved changes. This action will clear those. Do you want to continue?')) {
                        // When we abort the request, DataTable has already changed the page.
                        // The UI active class isn't added to the new page's button, but the button has been disabled.
                        // So, they can't click a page button, click cancel in the confirm dialog and then attempt to visit that page again (because that button was disabled).
                        // This next line allows them to attempt once more to visit that page (say, they changed their mind and don't care if they lose the changes they made).
                        _this.table.page($('#supply-issues-form .pagination > li.active > a').text() - 1);
                        return false;
                    }
                }
            },
            columns: [
                {name: 'checkbox', orderable: false, searchable: false},
                {name: 'abc8'},
                {name: 'ndc'},
                {name: 'ndcmultipleproductflag'},
                {name: 'ndcmultipleproductdesc', visible: false},
                {name: 'itemdesc'},
                {name: 'itemstatuscode'},
                {name: 'catmgrname'},

                {name: 'actions', orderable: false, searchable: false},
                {name: 'supply_issue_status_id', orderable: false, searchable: false},
                {name: 'tracking_status_date', orderable: false, searchable: false},
                {name: 'issue_description', orderable: false, searchable: false},
                {name: 'comments', orderable: false, searchable: false},

                {name: 'strength'},
                {name: 'form'},
                {name: 'size'},
                {name: 'itemdescfull', visible: false},
                {name: 'unitdosesap', visible: false},
                {name: 'metricsize', visible: false},
                {name: 'equivalentmetricsize', visible: false},
                {name: 'caseqty', visible: false},
                {name: 'packagetype', visible: false},
                {name: 'catmgrname', visible: false},
                {name: 'buyername', visible: false},
                {name: 'compareto'},
                {name: 'gcnseqnumber', visible: false},
                {name: 'gcndesc', visible: false},
                {name: 'gcndescfull', visible: false, searchable: true},
                {name: 'gpn'},
                {name: 'gcn'},
                {name: 'gsn'},
                {name: 'prxoitemstatus'},
                {name: 'program', visible: false},
                {name: 'materialgroup', visible: false},
                {name: 'materialpricinggroup', visible: false},
                {name: 'fedcontrolid', visible: false},
                {name: 'vendor8'},
                {name: 'vendorname'},
                {name: 'swpabclistflag', visible: false},
                {name: 'swp_abclist', visible: false},
                {name: 'supernet', visible: false},
                {name: 'wac'},
                {name: 'contractcost'},
                {name: 'contractcostoverride', visible: false},
                {name: 'netcost'},
                {name: 'deadnetcost'},
                {name: 'globalmarketprice'},
                {name: 'genericlaunchdate', visible: false},
                {name: 'therapeuticclass', visible: false},
                {name: 'ahfsclass', visible: false},
                {name: 'fdbcolor', visible: false},
                {name: 'fdbshape', visible: false},
                {name: 'fdbflavor', visible: false},
                {name: 'fdborangebook', visible: false},
                {name: 'wag'},
                {name: 'agflag', visible: false},
                {name: 'routedesc', visible: false},
                {name: 'injectableflag', visible: false},
                {name: 'gcnnti', visible: false},
                {name: 'seasonalgcn', visible: false},
                {name: 'brandflag', visible: false},
                {name: 'costcoawardflag', visible: false},
                {name: 'flatload', visible: false},
                {name: 'priceonvizient', visible: false},
                {name: 'priceontexasmedicaid', visible: false},
                {name: 'top5080', visible: false},
                {name: 'inventorydate'},
                {name: 'forecast'},
                {name: 'unitsonhand'},
                {name: 'daysonhand'},
                {name: 'unitsonorder'},
                {name: 'daysonorder', visible: false},
                {name: 'map', visible: false},
                {name: 'gpinumber', visible: false},
                {name: 'gpiopiodflag', visible: false},
                {name: 'gpiopiodname', visible: false},
                {name: 'contractgp', visible: false},
                {name: 'deadnetgp', visible: false},
                {name: 'netgp', visible: false},
                {name: 'salesperiodmonth', visible: false},
                {name: 'monthly_non_prxo_contract_cost_sales', visible: false},
                {name: 'monthly_non_prxo_invoice_sales', visible: false},
                {name: 'monthly_non_prxo_quantity'},
                {name: 'monthly_prxo_contract_cost_sales', visible: false},
                {name: 'monthly_prxo_invoice_sales', visible: false},
                {name: 'monthly_prxo_quantity'},
                {name: 'monthtodate', visible: false},
                {name: 'salesperioddaily', visible: false},
                {name: 'mtd_non_prxo_contract_cost_sales', visible: false},
                {name: 'mtd_non_prxo_invoice_sales', visible: false},
                {name: 'mtd_non_prxo_quantity', visible: false},
                {name: 'mtd_prxo_contract_cost_sales', visible: false},
                {name: 'mtd_prxo_invoice_sales', visible: false},
                {name: 'mtd_prxo_quantity', visible: false},
                {name: 'material', visible: false},
                {name: 'abc6', visible: false},
                {name: 'hdsitemnumber', visible: false},
                {name: 'pmgnitemstatus'},
                {name: 'pmgncontractcost'},
                {name: 'pmgndeadnetcost5'},
            ],

            buttons: [
            {
                extend: 'colvis',
                columns: ':not(.noVis)',
                prefixButtons: [
                    {
                        text: 'Show/Hide All',
                    },
                ]
            }
        ],
        });

        this.table.on('draw', () => abcsetup.formDirtyChecker.takeSnapshot(form));
    },

    /**
     * Change the table's url whenever the Supply Issue status button toggle changes state.
     *
     * @private
     */
    _bindStatusToggle() {
        const _this = this;

        $('.status-toggle').on('change', function () {
            const newVal = $(this).find(':checked').val();
            const newUrl = abcsetup.replaceUrlParameter(
                'rfq_supply_issue_status_id',
                newVal === 'off' ? '' : newVal,
                _this.table.ajax.url()
            );

            _this.table.ajax.url(newUrl).load();
        });
    },

    /**
     * Change the table's url whenever the RFQ Event status button toggle changes state.
     *
     * @private
     */
    _bindRfqEventStatusToggle() {
        const _this = this;

        $('.rfq-event-status-toggle').on('change', function () {
            const newVal = $(this).find(':checked').val();
            const newUrl = abcsetup.replaceUrlParameter(
                'rfq_event_status',
                newVal === 'off' ? '' : newVal,
                _this.table.ajax.url()
            );

            _this.table.ajax.url(newUrl).load();
        });
    },

    /**
     * Update the table's url whenever the GCN Family dropdown's value changes.
     *
     * @private
     */
    _bindGCNFamilyFilter() {
        const _this = this;

        $('select[name=gcn_family]').on('change', function () {
            const gcnDesc = $(this).find(':selected').data('gcndesc');
            const form = $(this).find(':selected').data('form');

            let newUrl = abcsetup.replaceUrlParameter('gcndesc', gcnDesc, _this.table.ajax.url());
            newUrl = abcsetup.replaceUrlParameter('form', form, newUrl);

            _this.table.ajax.url(newUrl).load();
        });
    },

    _setupCheckAllToggle() {
        $('.checkboxes').on('click', () => {
            const checkboxesColumn = this.table.columns('.checkboxes');
            const header = checkboxesColumn.header().to$();
            const checkThem = !header.data('all-checked');

            // Update header
            header.data('all-checked', checkThem);
            checkThem ? header.addClass('text-primary') : header.removeClass('text-primary');

            // Update checkboxes
            this._getItemRowCheckboxes().prop('checked', checkThem).trigger('change');
        });
    },

    /**
     * Setup the bulk event create button.
     * (which allows users to check boxes next to each item they want to include in an RFQ event. before creating the event we'll ensure each has an open supply issue.)
     *
     * @private
     */
    _setupBulkRFQEventCreate() {
        this._setupCheckAllToggle();
        this._setupRFQEventButtonDisabledToggle();

        $('#create-rfq-for-items-btn').on('click', e => {
            e.preventDefault();

            window.location.assign(
                '/rfq/supply_issues/create_event?sap_nums=' + this._getItemRowCheckedValues()
            );
        });
    },

    /**
     * Whenever and item's checkbox is checked, enable or disable the bulk event creat button depending on if we have any checked items.
     *
     * @private
     */
    _setupRFQEventButtonDisabledToggle() {
        const createRfqButton = $('#create-rfq-for-items-btn');
        const originalRfqButtonText = createRfqButton.text();

        this.table.on('draw', () => {
            const checkboxes = this._getItemRowCheckboxes();

            checkboxes.on('change', () => {
                const numChecked = checkboxes.filter(':checked').length;
                createRfqButton.attr('disabled', numChecked === 0);
                createRfqButton.text(numChecked > 0 ? `${originalRfqButtonText} (${numChecked})` : originalRfqButtonText);
            });
        });
    },

    /**
     * Get all the item checkboxes.
     *
     * @returns {*}
     * @private
     */
    _getItemRowCheckboxes() {
        return this.table.columns('.checkboxes')
            .nodes()
            .flatten()
            .to$()
            .find(':checkbox');
    },

    /**
     * Get all of the checked item sap numbers.
     *
     * @returns {*}
     * @private
     */
    _getItemRowCheckedValues() {
        return this._getItemRowCheckboxes().filter(':checked').toArray().map(el => $(el).val())
    },

    /**
     * An import of the updates template was completed.
     */
    uploadDone() {
        this.table.ajax.reload();
        abcsetup.alerts.flashMessage('Changes saved');
    },

    /**
     * Save changes to supply issues for the items on the current page.
     * @private
     */
    _bindFormSubmit() {
        const _this = this;

        $('#supply-issues-form').on('submit', function () {
            abcsetup.blockUI(true);
            abcsetup.formDirtyChecker.takeSnapshot(this);
            const formData = new FormData();
            $(this).serializeArray().forEach(field => {
                formData.append(field.name, field.value);
            });

            axios.post('/api/rfq/supply_issues', formData)
                .then(() => {
                    _this.table.ajax.reload(); // Once this is done, the UI will be un-blocked.
                    abcsetup.alerts.flashMessage('Changes saved');
                });

            return false;
        });
    },

    /**
     * Sets up the download button so the form is updated whenever the table changes
     * and when the button is pressed, the form is submitted.
     *
     * @private
     */
    _bindDownloadExportForm() {
        this.table.on('draw', () => {
            const abc8HiddenFields = this.table.columns('.abc8')
                .nodes()
                .flatten()
                .to$()
                .toArray()
                .map(e => `<input type="hidden" name="sap_nums[]" value="${e.innerText}">`)

            $('#download_template_form .sap_nums_container').empty().append(abc8HiddenFields);
        });

        $('#download_template_button').on('click', () => $('#download_template_form').trigger('submit'));
    },

    /**
     * Copy a supply issue from one item to many items.
     * Currently either across an entire GCN family or to items that are checked in the UI.
     */
    _bindCopySupplyIssueButtons() {
        const _this = this;

        this.table.on('draw', () => {
            $('.copy-supply-issue').on('click', function (e) {
                e.preventDefault();

                const checkboxes = _this._getItemRowCheckboxes();
                const numChecked = checkboxes.filter(':checked').length;
                const gcnFamily = String(this.dataset.gcn_family).trim();
                const supplyIssueId = this.dataset.supply_issue_id;

                if (numChecked === 0 && !String(this.dataset.gcndesc).trim()) {
                    abcsetup.alerts.show('Cannot Copy Supply Issue', 'This product does not have a GCN Family. To copy it, you must use the checkboxes.');
                    return;
                }

                const title = numChecked > 0
                    ? 'Copy Supply Issue &ndash; <span class="font-weight-bold">To Checked Items</span>'
                    : 'Copy Supply Issue &ndash; <span class="font-weight-bold">Across GCN Family</span>';
                const body = numChecked > 0
                    ? `Are you sure you would like to copy this supply issue to the <span class="font-weight-bold text-warning">${numChecked} checked item${numChecked === 1 ? '' : 's'}</span>?`
                    : `Are you sure you would like to copy this supply issue across all items in the <span class="font-weight-bold text-warning">${gcnFamily} family</span>?`;
                const requestData = numChecked > 0
                    ? {sap_nums: _this._getItemRowCheckedValues()}
                    : {gcndesc: this.dataset.gcndesc, form: this.dataset.form}

                abcsetup.alerts.confirm(title, body,
                    confirmed => {
                        if (confirmed) {
                            abcsetup.blockUI(true);
                            axios.post(`/api/rfq/supply_issues/copy/${supplyIssueId}`, requestData)
                                .then(() => {
                                    _this.table.ajax.reload(); // Once this is done, the UI will be un-blocked.
                                    abcsetup.alerts.flashMessage("You've successfully copied the supply issue");
                                })
                        }
                    }
                );
            })
        });
    },

    /**
     * We're not allowing a blank comment and an actual comment to be added at the same time.
     * So, when this is checked, we clear out the comment textarea and disable it.
     *
     * @private
     */
    _setupAddBlankCommentCheckbox() {
        $(document).on('change', ':checkbox.add_blank_comment_checkbox', (event) => {
            const commentBody = $(event.target).closest('td').find('textarea');
            commentBody.val(''); // No matter what, this should be empty when this checkbox changes its value.
            commentBody.attr('disabled', event.target.checked);
        });
    },
}
